export enum E_ArrowType {
    None = "None",
    Default = "Default",
    DefaultStatus = "DefaultStatus",
    RegularLastValue = "RegularLastValue",
    RegularInvertLastValue = "RegularInvertLastValue",
    MinMaxValue = "MinMaxValue"
}
